export default "__VITE_ASSET__CWWxgq8R__"